import React from "react";

const ExcecutiveSummary = ({ pfrFormData, setPfrFormData }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPfrFormData("excecutiveSummary", {
      [name]: value,
    });
  };

  return (
    <>
      <div className="form-section">
        <h3>Excecutive Summary</h3>
        <div className="form-group">
          <label className="required">LOI ref. no./Order copy</label>
          <input
            type="text"
            name="loiRefNo"
            value={pfrFormData.excecutiveSummary.loiRefNo}
            onChange={handleInputChange}
            placeholder="Enter LOI ref. no./Order copy"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Mine plan approval ref. no.</label>
          <input
            type="text"
            name="minePlanApprovalRefNo"
            value={pfrFormData.excecutiveSummary.minePlanApprovalRefNo}
            onChange={handleInputChange}
            placeholder="Enter Mine plan approval ref. no."
            required
          />
        </div>
        <div className="form-group">
          <label className="required">
            Cluster Information within 500m radius.
          </label>
          <input
            type="text"
            name="clusterInfo"
            value={pfrFormData.excecutiveSummary.clusterInfo}
            onChange={handleInputChange}
            placeholder="Enter Cluster Information within 500m radius."
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Old Excavated Pit Information</label>
          <input
            type="text"
            name="oldExcavatedPitInfo"
            value={pfrFormData.excecutiveSummary.oldExcavatedPitInfo}
            onChange={handleInputChange}
            placeholder="Enter Old Excavated Pit Information"
            required
          />
        </div>
        <h4>Surrounding Features</h4>
        <div className="form-group">
          <label className="required">Ecologically sensitive areas</label>
          <textarea
            type="text"
            name="ecologicallySensitiveAreas"
            value={pfrFormData.excecutiveSummary.ecologicallySensitiveAreas}
            onChange={handleInputChange}
            placeholder="Enter Ecologically sensitive areas"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">
            Reserved/protected forest within 10km distance
          </label>
          <textarea
            type="text"
            name="reservedForest"
            value={pfrFormData.excecutiveSummary.reservedForest}
            onChange={handleInputChange}
            placeholder="Enter Reserved/protected forest within 10km distance"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Water Bodies (with 500m)</label>
          <textarea
            type="text"
            name="waterBodies"
            value={pfrFormData.excecutiveSummary.waterBodies}
            onChange={handleInputChange}
            placeholder="Enter Water Bodies (with 500m)"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Connectivity</label>
          <textarea
            type="text"
            name="connectivity"
            value={pfrFormData.excecutiveSummary.connectivity}
            onChange={handleInputChange}
            placeholder="Enter Connectivity"
            required
          />
        </div>
        <h4>Project & Process Description</h4>
        <div className="form-group">
          <label className="required">Lithology of lease area</label>
          <textarea
            type="text"
            name="lithology"
            value={pfrFormData.excecutiveSummary.lithology}
            onChange={handleInputChange}
            placeholder="Enter Lithology of lease area"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Topography of lease area</label>
          <textarea
            type="text"
            name="topography"
            value={pfrFormData.excecutiveSummary.topography}
            onChange={handleInputChange}
            placeholder="Enter Topography of lease area"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Geological reserves</label>
          <textarea
            type="text"
            name="geologicalReserves"
            value={pfrFormData.excecutiveSummary.geologicalReserves}
            onChange={handleInputChange}
            placeholder="Enter Geological reserves"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Minning Method</label>
          <textarea
            type="text"
            name="miningMethod"
            value={pfrFormData.excecutiveSummary.miningMethod}
            onChange={handleInputChange}
            placeholder="Enter Minning Method"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Machineries used</label>
          <textarea
            type="text"
            name="machineriesUsed"
            value={pfrFormData.excecutiveSummary.machineriesUsed}
            onChange={handleInputChange}
            placeholder="Enter Machineries used"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Bench height & Bench width</label>
          <textarea
            type="text"
            name="benchHeightWidth"
            value={pfrFormData.excecutiveSummary.benchHeightWidth}
            onChange={handleInputChange}
            placeholder="Enter Bench height & Bench width"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Total soil generation</label>
          <textarea
            type="text"
            name="totalSoilGeneration"
            value={pfrFormData.excecutiveSummary.totalSoilGeneration}
            onChange={handleInputChange}
            placeholder="Enter Total soil generation"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Waste generation</label>
          <textarea
            type="text"
            name="wasteGeneration"
            value={pfrFormData.excecutiveSummary.wasteGeneration}
            onChange={handleInputChange}
            placeholder="Enter Waste generation"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Water and Wastewater</label>
          <textarea
            type="text"
            name="waterWastewater"
            value={pfrFormData.excecutiveSummary.waterWastewater}
            onChange={handleInputChange}
            placeholder="Enter Water and Wastewater"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Depth of mining</label>
          <textarea
            type="text"
            name="depthOfMining"
            value={pfrFormData.excecutiveSummary.depthOfMining}
            onChange={handleInputChange}
            placeholder="Enter Depth of mining"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">
            Plantation and green belt development
          </label>
          <textarea
            type="text"
            name="plantationGreenBelt"
            value={pfrFormData.excecutiveSummary.plantationGreenBelt}
            onChange={handleInputChange}
            placeholder="Enter Plantation and green belt development"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Project cost</label>
          <textarea
            type="text"
            name="projectCost"
            value={pfrFormData.excecutiveSummary.projectCost}
            onChange={handleInputChange}
            placeholder="Enter Project cost"
            required
          />
        </div>
      </div>
    </>
  );
};

export default ExcecutiveSummary;
